<template>
  <div v-show="isLoggedIn">
    <nav id="sidebar-dashboard" :class="isSuperAdmin ? 'admin-sidebar' : 'user-sidebar'" v-if="$router.currentRoute.name == 'dashboardMediaCalls'">
         <div class="workflow-title">Workflow</div>
    </nav>
    <nav id="sidebar" :class="isSuperAdmin ? 'admin-sidebar' : 'user-sidebar'" v-show="showSidebar" v-else>
      <ul class="list-unstyled components mb-5">
        <!-- <li title="My Week" class="nav-item has-sub-menu" @click.stop="!showMyWeekChild ? checkMyWeekActive(true) : checkMyWeekActive()" :class="{'parent-active': showMyWeekChild}">
          <a href="#" target="_self" class="nav-link">
            <img src="/images/my-week.svg?b7742d1871606e93b1efdb19c3ad6acf">
            <span class="menu-text">My Week</span>
          </a>
          <ul class="sub-menu list-unstyled components">
            <li title="My Deliverables" class="nav-item">
              <router-link to="/my-week" href="#" class="nav-link" target="_self">
                <span class="menu-text">My Deliverables</span>
              </router-link>
            </li>
            <li title="My Projects" class="nav-item">
              <router-link to="/my-projects" href="#" class="nav-link" target="_self">
                <span class="menu-text">My Projects</span>
              </router-link>
            </li>
          </ul>
        </li> -->
        <b-nav-item to="/my-week" title="My Week">
          <img src="@/csmworkflow/img/my-week.svg" />
          <span class="menu-text">My Week</span>
        </b-nav-item>
        <b-nav-item v-if="showMyProject" to="/my-projects" title="My Projects">
          <img src="@/csmworkflow/img/projects.svg" />
          <span class="menu-text">My Projects</span>
        </b-nav-item>
        <b-nav-item to="/media-calls" title="All Media Calls">
          <img src="@/csmworkflow/img/media-call-nav.svg" />
          <!-- <span class="menu-text">All Deliverables</span> -->
          <span class="menu-text">All Media Calls</span>
        </b-nav-item>
        <b-nav-item to="/all-deliverables" title="All Deliverables" v-if="!isOnlyMediaPreference">
          <img src="@/csmworkflow/img/home.svg" />
          <!-- <span class="menu-text">All Deliverables</span> -->
          <span class="menu-text">{{ allDeliverableTitle }}</span>
        </b-nav-item>
        <b-nav-item to="/deliverable-templates" title="Deliverable Templates" v-if="isSuperAdmin">
          <img src="@/csmworkflow/img/template-editor-icon-light.svg"/>
          <span class="menu-text">Deliverable Templates</span>
        </b-nav-item>

        <template v-if="showSocialGrouped">
          <b-nav-item to="/social-media-calendar" title="Social Media" v-if="!isOnlyMediaPreference">
            <img src="@/csmworkflow/img/social-media-white.svg" />
            <span class="menu-text">Social Media</span>
          </b-nav-item>
        </template>
        <template v-else-if="showSocialSchedule">
          <b-nav-item to="/social-media-schedule" title="Social Media" v-if="!isOnlyMediaPreference">
            <img src="@/csmworkflow/img/social-media-white.svg" />
            <span class="menu-text">Social Media</span>
          </b-nav-item>
        </template>
        <template v-else>
          <b-nav-item to="/social-media-schedule" title="Social Media" v-if="!isOnlyMediaPreference">
            <img src="@/csmworkflow/img/social-media-white.svg" />
            <span class="menu-text">Social Media</span>
          </b-nav-item>
        </template>

        <!-- <b-nav-item title="My Week" @click.stop="!showMyWeekChild ? checkMyWeekActive(true) : checkMyWeekActive()" :class="{'parent-active': showMyWeekChild}" class="has-sub-menu">
          <img src="@/csmworkflow/img/my-week.svg" />
          <span class="menu-text">My Week</span>
          <ul class="sub-menu list-unstyled components">
            <b-nav-item to="/my-week" title="My Deliverables">
              <span class="menu-text">My Deliverables</span>
            </b-nav-item>
            <b-nav-item to="/my-projects" title="My Projects">
              <span class="menu-text">My Projects</span>
            </b-nav-item>
          </ul>
        </b-nav-item> -->

        <b-nav-item to="/project" title="All Projects">
          <img src="@/csmworkflow/img/projects.svg" />
          <span class="menu-text">All Projects</span>
        </b-nav-item>
        <template v-if="isSuperAdmin">
          <b-nav-item to="/global-search" title="Global Search">
            <img src="@/csmworkflow/img/search.svg" />
            <span class="menu-text">Global Search</span>
          </b-nav-item>
          <b-nav-item to="/calendar" title="Calendar">
            <img src="@/csmworkflow/img/calendar.svg" />
            <span class="menu-text">Calendar</span>
          </b-nav-item>
          <b-nav-item to="/global-alert" title="Global Alert">
            <img src="@/csmworkflow/img/bell-regular.svg" />
            <span class="menu-text">Global Alert</span>
          </b-nav-item>
          <b-nav-item to="/report" title="Reports">
            <img src="@/csmworkflow/img/report.svg" />
            <span class="menu-text">Reports</span>
          </b-nav-item>
          <b-nav-item to="/dashboard/media-calls" title="Media Call Dashboard">
            <img src="@/csmworkflow/img/report.svg" />
            <span class="menu-text">Media Call Dashboard</span>
          </b-nav-item>
          <b-nav-item to="/audit-log" title="Audit Log">
            <img src="@/csmworkflow/img/audit-log.svg" />
            <span class="menu-text">Audit Log</span>
          </b-nav-item>
        </template>
        <li v-if="!isSuperAdmin" title="Advanced" class="nav-item has-sub-menu" @click.stop="!showAdvancedActive ? checkAdvancedActive(true) : checkAdvancedActive()" :class="{'parent-active': showAdvancedActive}">
          <a href="#" target="_self" class="nav-link">
            <img src="/images/my-week.svg?b7742d1871606e93b1efdb19c3ad6acf">
            <span class="menu-text">Advanced</span>
          </a>
          <ul class="sub-menu list-unstyled components">
            <li title="Global Search" class="nav-item">
              <router-link to="/global-search" href="#" class="nav-link" target="_self">
                <img src="@/csmworkflow/img/search.svg" />
                <span class="menu-text">Global Search</span>
              </router-link>
            </li>
            <li title="Calendar" class="nav-item">
              <router-link to="/calendar" href="#" class="nav-link" target="_self">
                <img src="@/csmworkflow/img/calendar.svg" />
                <span class="menu-text">Calendar</span>
              </router-link>
            </li>
            <li title="Global Alert" class="nav-item">
              <router-link to="/global-alert" href="#" class="nav-link" target="_self">
                <img src="@/csmworkflow/img/bell-regular.svg" />
                <span class="menu-text">Global Alert</span>
              </router-link>
            </li>
            <li title="Reports" class="nav-item">
              <router-link to="/report" href="#" class="nav-link" target="_self">
                <img src="@/csmworkflow/img/report.svg" />
                <span class="menu-text">Reports</span>
              </router-link>
            </li>
            <li title="Media Call Dashboard" class="nav-item">
              <router-link to="/dashboard/media-calls" href="#" class="nav-link" target="_self">
                <img src="@/csmworkflow/img/report.svg" />
                <span class="menu-text">Media Call Dashboard</span>
              </router-link>
            </li>
            <li title="Deliverable Templates" class="nav-item">
              <router-link to="/deliverable-templates" href="#" class="nav-link" target="_self">
                <img src="@/csmworkflow/img/template-editor-icon-light.svg" />
                <span class="menu-text">Deliverable Templates</span>
              </router-link>
            </li>
            <li title="Audit Log" class="nav-item">
              <router-link to="/audit-log" href="#" class="nav-link" target="_self">
                <img src="@/csmworkflow/img/audit-log.svg" />
                <span class="menu-text">Audit Log</span>
              </router-link>
            </li>


          </ul>
        </li>
        <b-nav-item @click.prevent="logout" class="logout-link d-none d-md-block" title="Logout">
          <img src="@/csmworkflow/img/logout.svg" />
          <span class="menu-text">Logout</span>
        </b-nav-item>
      </ul>
      <button type="button" id="sidebarCollapse" class="expand-menu">
        <img src="@/csmworkflow/img/expand-menu.svg" />
      </button>
      <div class="workflow-title">Workflow</div>
    </nav>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import $ from "jquery";
import router from '../../routes';

export default {
  computed: {
    ...mapGetters([
      "socialGroupBy"
    ]),
    isLoggedIn() {
      if (this.$router.currentRoute.name == 'dashboardMediaCalls'){
            return true;
        }else{
            return this.$store.getters.isLoggedIn;
        }
    },
    isSuperAdmin() {
      const userData = this.$store.getters.loggedInUserData;
      if (userData) {
        return userData.userRoles.some(x => x.id == 1);
      }
      return false;
    },
    myWeekParent() {
      return (router.currentRoute.name == 'myWeek' || router.currentRoute.name == 'myProjects')
    },
    allDeliverableTitle() {
      const deliverableTypes = this.$store.getters.deliverableTypes;
      if (deliverableTypes && deliverableTypes.length == 1) {
        if(typeof deliverableTypes[0].id != 'undefined' && deliverableTypes[0].id == 8) {
          return 'All Deliverables';
        } else {
          return `All ${deliverableTypes[0].name}s`;
        }
      } else {
        return "All Deliverables";
      }
    },
    isOnlyMediaPreference() {
      const deliverableTypes = this.$store.getters.deliverableTypes;
      if (deliverableTypes && deliverableTypes.length == 1) {
        if(typeof deliverableTypes[0].id != 'undefined' && deliverableTypes[0].id == "media_call") {
          return true;
        }
      }

      return false;
    },
    showMyProject() {
      return this.$store.getters.userHasProjects || this.$store.getters.userAbilities.createProject;
    },
    isSocialMedia() {
      let isSocial = false;
      if(router.currentRoute.name == 'socialMedia' || router.currentRoute.name == 'socialMediaGrouped'){
        isSocial = true;
      }
      console.log("isSocial: "+isSocial);
    },
    isSocialGrouped() {
      return (router.currentRoute.name == 'socialMediaGrouped');
    },
    showSidebar() {
      return this.$route.name !== 'duplicateProject'
    }
  },
  data() {
    return {
      showMyWeekChild: false,
      showAdvancedActive: false,
      showSocialGrouped: false,
      showSocialSchedule: false,
    }
  },
  methods: {
    checkMyWeekActive(clicked) {
      if(typeof clicked == 'undefined') {
        if(router.currentRoute.name == 'myWeek' || router.currentRoute.name == 'myProjects') {
          this.showMyWeekChild = true;
        } else {
          this.showMyWeekChild = false;
        }
      } else if(clicked) {
        this.showMyWeekChild = !this.showMyWeekChild;
      }
    },
    checkAdvancedActive(clicked) {
      if(typeof clicked == 'undefined') {
        if(router.currentRoute.name == 'globalSearch' || router.currentRoute.name == 'auditLog' ||
            router.currentRoute.name == 'globalAlert' || router.currentRoute.name == 'calendar' ||
            router.currentRoute.name == 'report') {
          this.showAdvancedActive = true;
        } else {
          this.showAdvancedActive = false;
        }
      } else if(clicked) {
        this.showAdvancedActive = !this.showAdvancedActive;
      }
    },
    checkSocialRoutes(){
      if(router.currentRoute.name == 'socialMedia' || router.currentRoute.name == 'socialMediaCalendarDetail'){
        this.showSocialGrouped = true;
        this.showSocialSchedule = false;
      } else if(router.currentRoute.name == 'socialMediaSchedule' || router.currentRoute.name == 'socialMediaScheduleDetail'){
        this.showSocialGrouped = false;
        this.showSocialSchedule = true;
      } else {
        this.showSocialGrouped = false;
        this.showSocialSchedule = false;
      }
    },
    logout() {
      if($('#update-logout').length) {
        let alertId = $('#update-logout').data('alertid');
        this.$store.dispatch('makeAlertRead', {alert: {id: alertId, loggedout: 'true'}});
      }
      this.$store.dispatch("logout").then(() => this.$router.push("/login"));
    },
    undo() {
      this.$store.dispatch('undoAction');
    }
  },
  updated() {
    $("#sidebar").removeClass("active");
  },
  mounted() {
    //   this.$router.currentRoute.name == 'mediaCallPage'
    if (this.$router.currentRoute.name == 'dashboardMediaCalls'){


    }else{
        this.checkMyWeekActive();
        this.checkAdvancedActive();
        this.checkSocialRoutes();
        $("#sidebarCollapse").on("click", function() {
        if ($("#sidebar").hasClass("active")) {
            $("#sidebar").removeClass("active");
            $("#content").addClass("side-nav-active");
        } else {
            $("#sidebar").addClass("active");
            $("#content").removeClass("side-nav-active");
        }
        });
    }
  },
  watch: {
    $route (to, from){
      this.checkMyWeekActive();
      this.checkAdvancedActive();
      this.checkSocialRoutes();
    }
  }
};
</script>

<style>
</style>
